import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import React, { useEffect, useState } from "react";
import { callAPI } from "../../../../lib/common";
import makeStyles from "@mui/styles/makeStyles";
import { usePictureSets } from "../../../hooks/usePictureSets";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Switch from "@mui/material/Switch";
import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";
import ListItemIcon from "@mui/material/ListItemIcon";
import AppBar from "../../Components/AppBar";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { usePortal } from "../../../../Providers/PortalProvider";
import { useAuth } from "../../../providers/AuthProvider";

const useStyles = makeStyles({
  root: {},
});

export default () => {
  const classes = useStyles();
  const portal = usePortal();
  const { t } = useTranslation();
  const { user, patchUser } = useAuth();

  console.log("The user is", user);

  const acceptMailLabel = portal.options.acceptMailDefaultOn
    ? "Yes, I agree to receive relevant offers by email. This applies only to the images I have been given secure access to from %s"
    : "Yes, I agree to receive promotional e-mails and SMS from %s";

  return (
    <MobilePage requireUser={true}>
      <AppBar />
      <PageHeader>
        <Trans>Communication settings</Trans>
      </PageHeader>
      <Container className={classes.root} maxWidth="sm">
        <Card>
          <CardContent>
            <Box display="flex" m={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="acceptmail"
                    style={{ marginRight: "20px" }}
                    checked={user.acceptMail ? true : false}
                    onChange={() =>
                      patchUser({ acceptMail: !user.acceptMail })
                    }
                  />
                }
                label={t(acceptMailLabel, {
                  postProcess: "sprintf",
                  sprintf: [portal.name],
                })}
              />
            </Box>
            <Divider />
            <p>
              <Trans>
                Uncheck the picture sets you do not want to receive
                notifications for.
              </Trans>
            </p>
            <SubjectList />
          </CardContent>
        </Card>
      </Container>
    </MobilePage>
  );
};

const SubjectList = () => {
  const [enabledSubjects, setEnabledSubjects] = useState(null);
  const { t } = useTranslation();
  const { pictureSets, isLoaded } = usePictureSets();
  const [initDone, setInitDone] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    callAPI("/ajax/user/get_subjects_with_reminders_enabled.php").then(
      ({ subjects }) => {
        setEnabledSubjects(subjects.map((subject) => subject.uuid));
      },
    );
  }, []);

  useEffect(() => {
    if (enabledSubjects !== null) {
      // Hacky way to avoid triggering update on first data load:
      if (initDone) {
        const data = pictureSets.map((pictureSet) => {
          return {
            name: pictureSet.subject.name,
            uuid: pictureSet.subject.uuid,
            remindersEnabled:
              enabledSubjects.indexOf(pictureSet.subject.uuid) >= 0,
          };
        });
        callAPI("/ajax/user/set_reminders_disabled_status.php", "POST", {
          subjects: data,
        });
      }
      setInitDone(true);
    }
  }, [enabledSubjects]);

  const toggle = (e) => {
    enabledSubjects.indexOf(e.target.name) >= 0
      ? setEnabledSubjects((enabledSubjects) =>
          enabledSubjects.filter((uuid) => uuid != e.target.name),
        )
      : setEnabledSubjects((enabledSubjects) => [
          ...enabledSubjects,
          e.target.name,
        ]);
  };

  const toggleAll = () => {
    enabledSubjects.length == pictureSets.length
      ? setEnabledSubjects([])
      : setEnabledSubjects(pictureSets.map((ps) => ps.subject.uuid));
  };

  if (enabledSubjects === null || !isLoaded) {
    return <div>Loading</div>;
  }

  return (
    <List className={classes.root}>
      <ListItem>
        <ListItemIcon>
          <GroupIcon />
        </ListItemIcon>
        <ListItemText
          id="switch-list-label-wifi"
          primary={t("All picture sets")}
        />
        <ListItemSecondaryAction>
          <Switch
            edge="end"
            onChange={toggleAll}
            checked={enabledSubjects.length == pictureSets.length}
            inputProps={{ "aria-labelledby": "switch-list-label-wifi" }}
          />
        </ListItemSecondaryAction>
      </ListItem>
      {pictureSets.map((pictureSet) => {
        return (
          <ListItem key={pictureSet.subject.uuid}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText
              id="switch-list-label-wifi"
              primary={pictureSet.subject.name}
            />
            <ListItemSecondaryAction>
              <Switch
                edge="end"
                name={pictureSet.subject.uuid}
                onChange={toggle}
                checked={enabledSubjects.indexOf(pictureSet.subject.uuid) >= 0}
                inputProps={{ "aria-labelledby": "switch-list-label-wifi" }}
              />
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};
